type Props = {
  aberta?: boolean;
  quantidade?: number;
  expandida?: boolean;
  aoClicar?: () => void;
  ref?: React.Ref<HTMLButtonElement>;
};

/**
 * Ícone desenhado da Lixeira (canto inferior esquerdo), sem fundo, com a quantidade num selo embaixo. A tampa abre quando `aberta` é verdadeiro: um cartão
 * arrastado passa por cima ou a confirmação de envio está na tela (RQ-EST-010). O clique abre o painel da Lixeira.
 */
export function Lixeira({ aberta = false, quantidade = 0, expandida = false, aoClicar, ref }: Props) {
  return (
    <button
      ref={ref}
      type="button"
      className={`lixeira${aberta ? ' lixeira--aberta' : ''}`}
      aria-label={`Lixeira (${quantidade})`}
      aria-expanded={expandida}
      aria-controls="painel-lixeira"
      onClick={aoClicar}
    >
      <svg viewBox="0 0 64 64" width="62" height="62" aria-hidden>
        <g className="lixeira__tampa">
          <rect x="14" y="13" width="36" height="6" rx="3" />
          <rect x="26" y="8" width="12" height="6" rx="2.5" />
        </g>
        <path className="lixeira__corpo" d="M17 22h30l-2.6 31.2A4 4 0 0 1 40.4 57H23.6a4 4 0 0 1-4-3.8z" />
        <path className="lixeira__frisos" d="M26 29v20M32 29v20M38 29v20" />
      </svg>
      {quantidade > 0 && <span className="lixeira__contador">{quantidade}</span>}
    </button>
  );
}
